import React, { useState } from 'react';

function Search(props) {
    const resourcedTexts = props.resourcedTexts;
    const [mobileSearchVisible, setMobileSearchVisible] = useState(false);

    const searchClasses = `search ${mobileSearchVisible ? 'search--visible-on-mobile' : ''}`;

    return (
        <>
            <button
                className="mobile-search-toggle"
                type="button"
                onClick={() => setMobileSearchVisible(!mobileSearchVisible)}
            >
                {resourcedTexts.searchButtonText}
            </button>

            <form className={searchClasses} onSubmit={props.onSubmit}>
                <input
                    type="search"
                    placeholder={resourcedTexts.searchPlaceholder}
                    name="search"
                    title={resourcedTexts.searchPlaceholder}
                    aria-label={resourcedTexts.searchButtonText}
                    value={props.searchTerm}
                    onChange={props.onChange}
                />

                <button>
                    <span className="visually-hidden">{resourcedTexts.searchButtonText}</span>
                </button>
            </form>
        </>
    );
}

export { Search };
